import { DefaultPageHeader } from 'layouts';
import {
  AxiosErrorHandler,
  Card,
  Col,
  type EmptyProperties,
  InfinityLoading,
  Loading,
  Row,
  withErrorBoundary,
} from 'ui';
import { ContentObjectFeedEmptyState } from '../content-object-feed';
import { ContentObjectRenderer } from '../content-object-renderer';
import { useBookmarksFeedInfiniteQuery } from '../queries';

type P = {
  emptyState?: EmptyProperties;
};

const BookmarksFeed = ({ emptyState }: P) => {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isLoading } = useBookmarksFeedInfiniteQuery({
    limit: 7,
  });

  const items = data?.pages.flat();

  return (
    <>
      <DefaultPageHeader title="Bookmarks" />
      <AxiosErrorHandler error={error}>
        {isLoading || !items ? (
          <Loading />
        ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
        items.length === 0 ? (
          <ContentObjectFeedEmptyState emptyState={emptyState} />
        ) : (
          <Row gutter={[0, 'ms']}>
            {items.map((item) => (
              <Col key={item.id} span={24}>
                <Card marginBottom={false}>
                  <ContentObjectRenderer item={item} key={item.id} view="bookmark" />
                </Card>
              </Col>
            ))}
            <Col span={24}>
              <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
            </Col>
          </Row>
        )}
      </AxiosErrorHandler>
    </>
  );
};

export default withErrorBoundary(BookmarksFeed);
